module.exports = __webpack_public_path__ + "8710fbff.woff2";